/**
 * DropDownTitle
 * @module components/DropDownTitle
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'common/Link/Link';

/** Class representing the component. */
class DropDownTitle extends Component {

	/**
	 * Prevents click if nothing's specified
	 * @param {Object} e 
	 */
	handleClick (e) {
		if (!this.props.clickable) {
			e.preventDefault()
		}
	}

	/**
	 * The render method
	 */
	render () {
		const { href, children } = this.props;

		return (
			<Link route={ href || '#' }>
				<a onClick={(e) => this.handleClick(e)}>
					{ children }
				</a>
			</Link>
		);
	}
}


DropDownTitle.propTypes = {
	children: PropTypes.node,
	href: PropTypes.string,
	clickable: PropTypes.bool
};


export default DropDownTitle;
